import { render } from "./hotelview.vue?vue&type=template&id=135792ad"
import script from "./hotelview.vue?vue&type=script&lang=js"
export * from "./hotelview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__